var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src: _vm.fullSrc, loading: _vm.loading, error: _vm.error}),expression:"{src: fullSrc, loading: loading, error: error}"}],ref:"ele"})
}
var staticRenderFns = []

export { render, staticRenderFns }